import { render, staticRenderFns } from "./CollapseOtherSummaryPanel.vue?vue&type=template&id=60bcd4e3&scoped=true&"
import script from "./CollapseOtherSummaryPanel.vue?vue&type=script&lang=js&"
export * from "./CollapseOtherSummaryPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bcd4e3",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VBtn,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60bcd4e3')) {
      api.createRecord('60bcd4e3', component.options)
    } else {
      api.reload('60bcd4e3', component.options)
    }
    module.hot.accept("./CollapseOtherSummaryPanel.vue?vue&type=template&id=60bcd4e3&scoped=true&", function () {
      api.rerender('60bcd4e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Delegation/DelegationFormStandard/other/CollapseOtherSummaryPanel.vue"
export default component.exports